export class TimeOverlay {

    constructor(widget){
      this.timeLogger = document.createElement("div");
      this.timeLogger.classList.add('time-log');
      widget.DOMElement.appendChild(this.timeLogger);    
      widget.addTickHandler(this.tickHandler.bind(this));
    }
  
    tickHandler(simTime, lastSimTime){
      this.timeLogger.innerText = simTime.toString();
    }
  
  }